export default function isOneOf(one, ofTarget) {
  if (Array.isArray(ofTarget)) {
    return ofTarget.indexOf(one) >= 0;
  }

  return one === ofTarget;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/rsuite/es/utils/isOneOf.js
// module id = 980
// module chunks = 31